import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';

const consumerWalletKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'consumerWallet'] as const,
  });

export { consumerWalletKeys };
